export default "__VITE_ASSET__sNHoaWJB__"